import React, { Component } from 'react';
import '../../App.css'
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioFormatos from '../servicios/ServicioFormatos';
import servicioReceptor from '../servicios/ServicioReceptor';
import servicioTicket from '../servicios/ServicioTicket';
import servicioDescargaArchivos from '../servicios/ServicioArchivos';
import servicioComplementoIne11 from '../servicios/ServicioComplementoIne11';
import { getIdentificador } from '../servicios/ServicioIdentificadorNavegador';
import { deleteToken } from '../servicios/ServicioManejadorToken';
import { setToken } from '../servicios/ServicioManejadorToken';
import servicioHttp from '../servicios/ServicioHttp';
import QrReader from 'react-qr-scanner';
import ServicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';

export default class FacturacionTickets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ticket: {},
            receptor: {},
            erroresFrmDatosFiscales: {},
            usosCfdi: [],
            erroresFrmTicket: {},
            tickets: [],
            mostrarModalEliminar: false,
            mostrarModalResultado: false,
            listaResultados: [],
            complementoIne: null,
            elementosComplementoIne: {},
            mostrarComplementoIne: false,
            delayQr: 100,
            resultadoQr: '',
            mostrarSeccionLectorQr: false,
            textoBotonQr: "Activar cámara escanear QR",
            desActivarTipoComite: false,
            desActivar_complementoIne_idContabilidad: false,
            desActivar_entidad_claveEntidad: false,
            desActivar_entidad_ambito: false,
            desActivar_entidad_contabilidad_idContabilidad: false,
            cfdiPorCodigo: false,
            confirmacionFacturacion: false,
            listaRegimenFiscalReceptor: []
        }
        this.servicioLogeo();
        // this.buscarTickets();
    }

    servicioLogeo = () => {
        let { esFacturacionSingistro } = this.props;
        if (esFacturacionSingistro === true) {
            getIdentificador().then(response => {
                deleteToken();
                servicioHttp.consumirPostHttp('/sinregistro/autenticar_invitado').then(response => {
                    let token = response.headers['authorization'];
                    setToken(token);
                    this.buscarTickets();
                }).catch(error => {
                    this.growl.show({ severity: 'error', summary: 'Error', detail: "No se puede realizar la conexión al servidor intente más tarde", life: 5000 });
                });
            }).catch(error => {

            });
        } else {
            this.buscarTickets();
        }

    }

    buscarTickets = () => {
        let { urlBusquedaTickets } = this.props;
        servicioTicket.buscarTickets(urlBusquedaTickets).then(response => {
            this.setState({ tickets: response.data.lista });
        }).catch(error => {

        });
    }

    buscarReceptor = () => {
        let { urlBusquedaReceptor, urlRegimenFiscal } = this.props;
        let { receptor, erroresFrmDatosFiscales,listaRegimenFiscalReceptor,usosCfdi } = this.state;
        erroresFrmDatosFiscales = {};
        delete receptor.usoCfdi;
        if (receptor.rfc !== undefined && receptor.rfc.length >= 12) {
            if (receptor.rfc === "XEXX010101000" || receptor.rfc === "XAXX010101000") {
                receptor['domicilioFiscalReceptor']="00000";
                let objetoRegimen={ "id": "616", "descripcion": "Sin obligaciones fiscales" };
                let objetoUsoCfdi={ "id": "S01", "descripcion": "Sin efectos fiscales." };
                listaRegimenFiscalReceptor=[objetoRegimen];
                usosCfdi=[objetoUsoCfdi];
                receptor['usoCfdi'] = objetoUsoCfdi;
				receptor['regimenFiscalReceptor'] = objetoRegimen;
                this.setState({receptor:receptor,listaRegimenFiscalReceptor:listaRegimenFiscalReceptor,usosCfdi:usosCfdi});
            } else {
                servicioReceptor.buscarRfcReceptorPorRfc(urlBusquedaReceptor, { rfc: receptor.rfc }).then(response => {
                    if (!response.error) {
                        // receptor = response.data.objeto;
                        if (response.data.error) {
                            erroresFrmDatosFiscales.rfc = response.data.mensaje;
                            receptor = {};
                        } else {
                            servicioHttp.consumirPostHttp(urlRegimenFiscal, { rfc: receptor.rfc }).then(response => {
                                receptor.regimenFiscalReceptor = null;
                                this.setState({ listaRegimenFiscalReceptor: response.data.lista, receptor });
                            });
                        }
                        this.setState({ receptor: receptor });
                        this.setState({ erroresFrmDatosFiscales: erroresFrmDatosFiscales });
                    }
                }).catch(error => {

                });
            }

        } else {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "La longitud del rfc debe de ser mínimo de 12 caracteres" });
        }
    }

    validarCodigo = (event) => {
        event.preventDefault();
        let erroresFrmDatosFiscales = this.validarFomularioDatosFiscales();
        this.setState({ erroresFrmDatosFiscales: erroresFrmDatosFiscales });
        if (!Object.keys(erroresFrmDatosFiscales).length) {
            let { ticket } = this.state;
            const resultadoValidacion = this.validarFormularioCodigo(ticket);
            this.setState({ erroresFrmTicket: resultadoValidacion });
            if (!Object.keys(resultadoValidacion).length) {
                this.invocarServicioValidacionTicket(ticket);
            }
        }

    }


    invocarServicioValidacionTicket = (ticket) => {
        let { urlValidarTickets } = this.props;
        servicioTicket.validarTicket(urlValidarTickets, ticket).then(response => {
            let respuesta = response.data;
            let { erroresFrmTicket } = this.state;
            if (respuesta.error === true) {
                erroresFrmTicket.codigo = respuesta.mensaje;
                this.setState({ erroresFrmTicket: erroresFrmTicket });
            } else {
                let severity = 'success';
                let life = 8000;
                if (respuesta.mensaje.indexOf("problema") !== -1) {
                    severity = 'error';
                    life = 90000;
                }

                this.growl.show({ severity: severity, summary: 'Éxito', detail: respuesta.mensaje, life: life });
                this.setState({ ticket: {} });
                this.buscarTickets();
            }
        }).catch(error => {

        });
    }

    validarFomularioDatosFiscales = () => {
        let errores = {};
        let { receptor } = this.state;

        if (!receptor.rfc)
            errores.rfc = "El rfc del receptor es requerido";
        if (!receptor.nombre)
            errores.nombre = "El nombre del receptor es requerido";
        if (!receptor.usoCfdi)
            errores.usoCfdi = "El uso Cfdi es requerido";
        if (!receptor.correo) {
            errores.correo = "El correo es requerido";
        } else {
            this.validarCorreo(receptor.correo, errores);
        }
        if (ServicioAsignacionValoresObjetos.esObjetoVacio(receptor.domicilioFiscalReceptor))
            errores.domicilioFiscalReceptor = "El Domicilio Fiscal es requerido";
        if (ServicioAsignacionValoresObjetos.esObjetoVacio(receptor.regimenFiscalReceptor))
            errores.regimenFiscalReceptor = "El Regimen Fiscal es requerido";
        return errores;
    }

    validarCorreo = (correo, errores) => {
        var patronCorreo = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        const valorvalidacion = patronCorreo.exec(correo);
        if (null === valorvalidacion)
            errores.correo = "Ingrese un correo valido";
    }

    validarFormularioCodigo = (ticket) => {
        const errores = {};
        if (!ticket.codigo)
            errores.codigo = "El código de 18 caracteres es un valor requerido";
        return errores;
    }

    asignarValoresObjeto = (event) => {
        if (event.target.id === "regimenFiscalReceptor") {
            this.buscarUsoCfdiRegimenFiscalRfcReceptor(event.target.value);
        }
        if (event.target.id === "correo") {
            ServicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
        } else
            servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    }

    templateColumnaImporte = (rowData, column) => {
        return <div>{servicioFormatos.formatearModena(rowData[4])}</div>;
    }

    cambiarFechaTicket = (event, props) => {
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(event.value.llave)) {
            let { urlActualizarFechaTicket } = this.props;
            let tickets = [...props.value];
            let idTicket = tickets[props.rowIndex][0];
            servicioHttp.consumirPostHttp(urlActualizarFechaTicket, { id: idTicket, fechaTicket: event.value.llave }).then(response => {
                this.growl.show({ severity: 'success', summary: 'Éxito', detail: "Fecha actualizada con éxito", life: 5000 });
                this.buscarTickets();
            }).catch(error => {

            });
        }
    }

    templateColumnaFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFechaYYYYMMDDHHmmss(rowData[3])} {rowData[5] === 1 ? <Button tooltip="Editar fecha código" type="button" icon="pi-md-edit" className="p-button-warning"></Button> : null}</div>;
    }

    editorColumnaFecha = (props) => {
        let rowData = props.rowData;
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(rowData[6])) {
            let dataList = JSON.parse(rowData[6]);
            return (
                <Dropdown appendTo={document.body} dataKey="idFecha" optionLabel="valor" placeholder="Seleccione una fecha" options={dataList} value={props.value[props.rowIndex][3]} onChange={(e) => this.cambiarFechaTicket(e, props)} />
            );
        }

    }

    templateBorrarTicket = (rowData, column) => {
        return <div>
            <Button tooltip="Eliminar código" type="button" icon="pi-md-delete" className="p-button-warning" onClick={(e) => this.mostrarEliminarTicket(rowData)}></Button>
        </div>;
    }

    mostrarEliminarTicket = (rowData) => {
        this.setState({ mostrarModalEliminar: true, elIdTicket: rowData[0], elTicket: rowData[2] });
    }

    borrarCodigo = () => {
        let { urlEliminarTickets } = this.props;
        let { elIdTicket } = this.state;
        this.setState({ mostrarModalEliminar: false });
        servicioTicket.eliminarTicket(urlEliminarTickets, { id: elIdTicket }).then(response => {
            this.buscarTickets();
        }).catch(error => {

        });
    }

    cerrarEliminarCodigo = () => {
        this.setState({ mostrarModalEliminar: false });
    }

    pre_facturar = () => {
        let erroresFrmDatosFiscales = this.validarFomularioDatosFiscales();
        this.setState({ erroresFrmDatosFiscales: erroresFrmDatosFiscales });
        if (!Object.keys(erroresFrmDatosFiscales).length) {
            let { urlValidarReceptor40 } = this.props;
            let { receptor } = this.state;

            if (receptor.rfc === "XEXX010101000" || receptor.rfc === "XAXX010101000") {
                this.setState({ confirmacionFacturacion: true });
            }else{
                let receptorEnvio = { rfc: receptor.rfc, nombre: receptor.nombre, domicilioFiscalReceptor: receptor.domicilioFiscalReceptor, regimenFiscalReceptor: receptor.regimenFiscalReceptor.id, usoCfdi: receptor.usoCfdi.id };
                servicioHttp.consumirPostHttp(urlValidarReceptor40, receptorEnvio).then(response => {
                    let validacionDatosFiscales = response.data.error;
                    if (validacionDatosFiscales) {
                        this.growl.show({ severity: 'error', summary: 'Error', detail: response.data.mensaje, life: 5000 });
                    } else {
                        this.setState({ confirmacionFacturacion: true });
                    }
                })
            }

           



        }
    }

    facturar = () => {
        this.cerrarModalConfirmacion();
        let { receptor, cfdiPorCodigo } = this.state;
        let { urlGenerarFacturaTickets } = this.props;
        var receptorEnvio = JSON.parse(JSON.stringify(receptor));
        let usoCfdi = receptorEnvio.usoCfdi.id;
        delete receptorEnvio['usoCfdi'];
        receptorEnvio.usoCfdi = usoCfdi;
        let regimenFiscalReceptor = receptorEnvio.regimenFiscalReceptor.id;
        delete receptorEnvio['regimenFiscalReceptor'];
        receptorEnvio.regimenFiscalReceptor = regimenFiscalReceptor;
        this.obtenerComplementoIne(receptorEnvio);
        receptorEnvio.dividirCodigos = cfdiPorCodigo;
        servicioTicket.generarFactura(urlGenerarFacturaTickets, receptorEnvio).then(response => {
            this.buscarTickets();
            let respuesta = response.data;
            let listaResultados = respuesta.lista;
            this.setState({ mostrarModalResultado: true });
            this.setState({ listaResultados: listaResultados });
        }).catch(error => {
            this.buscarTickets();
        });
    }

    obtenerComplementoIne = (receptor) => {
        let { complementoIne } = this.state;
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne)) {
            let complementoIne1_1 = {};
            complementoIne1_1.version = "1.1";
            if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.tipoProceso))
                complementoIne1_1.tipoProceso = complementoIne.tipoProceso.valor;

            if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.tipoComite))
                complementoIne1_1.tipoComite = complementoIne.tipoComite.valor;

            if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.idContabilidad))
                complementoIne1_1.idContabilidad = complementoIne.idContabilidad;

            let entidad = {};
            if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.entidad_claveEntidad))
                entidad.claveEntidad = complementoIne.entidad_claveEntidad.valor;

            if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.entidad_ambito))
                entidad.ambito = complementoIne.entidad_ambito.valor;

            let inde_entidad_contabilidad = {};
            if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.entidad_contabilidad_idContabilidad))
                inde_entidad_contabilidad.idContabilidad = complementoIne.entidad_contabilidad_idContabilidad;

            if (!servicioAsignacionValoresObjetos.esObjetoVacio(inde_entidad_contabilidad)) {
                entidad.contabilidad = [];
                entidad.contabilidad[0] = inde_entidad_contabilidad;
            }

            if (!servicioAsignacionValoresObjetos.esObjetoVacio(entidad)) {
                complementoIne1_1.entidad = [];
                complementoIne1_1.entidad[0] = entidad;
            }

            if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne1_1))
                receptor.ine11 = complementoIne1_1;
        }
    }

    templateDescargaArchivos = (rowData, column) => {
        return <div>
            <Button type="button" icon="pi-md-cloud-download" className="p-button-success" onClick={(e) => this.descargaArchivos(rowData)}></Button>
        </div>;
    }

    templateErrorResultado = (rowData, column) => {
        if (rowData.error === true)
            return <div className="p-col-12 p-md-2"><i className="pi-md-cancel"></i></div>;
        else
            return <div className="p-col-12 p-md-2"><i className="pi-md-check-circle"></i></div>;
    }

    descargaArchivos = (rowData) => {
        let { urlDescargaArchivosFacturacion } = this.props;
        servicioDescargaArchivos.descargaArchivo(urlDescargaArchivosFacturacion, { id: rowData.objeto.busqueda });
    }

    cerrarModalResultados = () => {
        this.setState({ mostrarModalResultado: false });
    }

    manejarEscaneoQr = (data) => {
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(data)) {
            this.invocarServicioValidacionTicket({ codigo: data.replace(/ /g, '') });
        }
    }

    manejarErrorEscaneoQr = (error) => {

    }

    activarLectorQr = () => {

        let erroresFrmDatosFiscales = this.validarFomularioDatosFiscales();
        this.setState({ erroresFrmDatosFiscales: erroresFrmDatosFiscales });

        if (!Object.keys(erroresFrmDatosFiscales).length) {
            let { mostrarSeccionLectorQr } = this.state;
            mostrarSeccionLectorQr = !mostrarSeccionLectorQr;
            let textoBotonQr = "Activar camara escanear QR";
            if (mostrarSeccionLectorQr === true)
                textoBotonQr = "Desactivar camara escanear QR"

            this.setState({ textoBotonQr: textoBotonQr });
            this.setState({ mostrarSeccionLectorQr: mostrarSeccionLectorQr });
        }
    }

    templateUsoCfdi = (option) => {
        return (
            <div className="p-clearfix">
                <span >{option.id} - {option.descripcion}</span>
            </div>
        );
    }

    templateRegimenFiscal = (option) => {
        return (
            <div className="p-clearfix">
                <span >{option.id} - {option.descripcion}</span>
            </div>
        );
    }

    crearEliminarComplmentoIne = (e) => {

        let elComplementoIne = null;
        if (true === e.checked) {
            let { urlObtenerElementosIne11 } = this.props;
            elComplementoIne = {};
            servicioComplementoIne11.obtenerElementosIne11(urlObtenerElementosIne11).then(response => {
                this.setState({ elementosComplementoIne: response.data });
            }).catch(error => {

            });
        }
        this.setState({ mostrarComplementoIne: e.checked });
        this.setState({ complementoIne: elComplementoIne });
    }


    validarTipoProceso = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
        let { complementoIne } = this.state;
        if (null !== complementoIne) {
            if ("Ordinario" === complementoIne.tipoProceso.llave) {
                this.setState({ desActivarTipoComite: false });
                this.setState({ desActivar_complementoIne_idContabilidad: false });
            } else {
                complementoIne.tipoComite = null;
                complementoIne.idContabilidad = null;
                this.setState({ desActivarTipoComite: true });
                this.setState({ desActivar_complementoIne_idContabilidad: true });
                complementoIne.entidad_claveEntidad = null;
                complementoIne.entidad_ambito = null;
                complementoIne.entidad_contabilidad_idContabilidad = null;
                this.setState({ desActivar_entidad_claveEntidad: false });
                this.setState({ desActivar_entidad_ambito: false });
                this.setState({ desActivar_entidad_contabilidad_idContabilidad: false });
            }
        }
    }

    validarTipoComite = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
        let { complementoIne } = this.state;
        if (null !== complementoIne) {
            if ("Ejecutivo Nacional" === complementoIne.tipoComite.llave) {
                this.setState({ desActivar_complementoIne_idContabilidad: false });
                complementoIne.entidad_claveEntidad = null;
                complementoIne.entidad_ambito = null;
                complementoIne.entidad_contabilidad_idContabilidad = null;
                this.setState({ desActivar_entidad_claveEntidad: true });
                this.setState({ desActivar_entidad_ambito: true });
                this.setState({ desActivar_entidad_contabilidad_idContabilidad: true });
            } else if ("Ejecutivo Estatal" === complementoIne.tipoComite.llave) {
                complementoIne.idContabilidad = null;
                complementoIne.entidad_ambito = null;
                this.setState({ desActivar_complementoIne_idContabilidad: true });
                this.setState({ desActivar_entidad_claveEntidad: false });
                this.setState({ desActivar_entidad_ambito: true });
                this.setState({ desActivar_entidad_contabilidad_idContabilidad: false });
            } else if ("Directivo Estatal" === complementoIne.tipoComite.llave) {
                complementoIne.idContabilidad = null;
                complementoIne.entidad_ambito = null;
                this.setState({ desActivar_complementoIne_idContabilidad: false });
                this.setState({ desActivar_entidad_claveEntidad: false });
                this.setState({ desActivar_entidad_ambito: true });
                this.setState({ desActivar_entidad_contabilidad_idContabilidad: false });
            }

            this.setState({ complementoIne: complementoIne });
        }
    }

    cerrarModalConfirmacion = () => {
        this.setState({ confirmacionFacturacion: false })
    }

    asignarNumero = (e) => {
        this.setState({ numero: e.value });
    }

    buscarUsoCfdiRegimenFiscalRfcReceptor = (objeto) => {
        let { urlBusquedaUsosCfdi } = this.props;
        let { receptor } = this.state;
        console.log(objeto);
        servicioHttp.consumirPostHttp(urlBusquedaUsosCfdi, {
            'rfc': receptor.rfc,
            'regimenFiscal': objeto.id
        }).then(response => {
            this.setState({ usosCfdi: response.data.lista });
        });
        receptor.usoCfdi = null;
        this.setState({ receptor: receptor });
    }

    render() {

        const previewStyle = {
            height: 240,
            width: 320,
        }

        let { receptor, erroresFrmDatosFiscales, usosCfdi, ticket, erroresFrmTicket, tickets,
            mostrarModalEliminar, mostrarModalResultado, elTicket, listaResultados, complementoIne, elementosComplementoIne, mostrarComplementoIne, delayQr,
            resultadoQr, mostrarSeccionLectorQr, textoBotonQr, desActivarTipoComite, desActivar_complementoIne_idContabilidad,
            desActivar_entidad_claveEntidad, desActivar_entidad_ambito, desActivar_entidad_contabilidad_idContabilidad, cfdiPorCodigo, listaRegimenFiscalReceptor } = this.state;

        const piePaginaModalEliminar = (
            <div>
                <Button label="Si" icon="pi pi-check" onClick={this.borrarCodigo} />
                <Button label="No" icon="pi pi-times" className="p-button-secondary" onClick={this.cerrarEliminarCodigo} />
            </div>
        );


        const piePaginaModalRestultados = (
            <div>
                <Button label="Cerrar" icon="pi pi-times" onClick={this.cerrarModalResultados} />
            </div>
        );

        const seccionLectorQr = (
            <div>
                <div className="p-grid">
                    <div className="p-col-12 p-md-4">

                    </div>
                    <div className="p-col-12 p-md-4">
                        <QrReader
                            delay={delayQr}
                            style={previewStyle}
                            onError={this.manejarErrorEscaneoQr}
                            onScan={this.manejarEscaneoQr}
                        />
                        <p>{resultadoQr}</p>
                    </div>
                    <div className="p-col-12 p-md-4">

                    </div>
                </div>
            </div>
        );

        const dialogFooterConfirmacionFacturacion = (
            <div>
                <Button icon="pi-md-check" onClick={this.facturar} label="Si estoy seguro" className="teal-btn flat-btn" />
                <Button icon="pi-md-close" onClick={this.cerrarModalConfirmacion} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );

        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card card-w-title">
                            <h4 style={{ marginTop: '1px', marginBottom: '30px', fontWeight: 'bold' }}>Capturar datos fiscales</h4>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="rfc">* RFC:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <InputText id="rfc" name="receptor.rfc" value={receptor.rfc || ''} onChange={this.asignarValoresObjeto} className={erroresFrmDatosFiscales.rfc ? 'p-error' : ''} placeholder="RFC" onBlur={this.buscarReceptor} />
                                    {erroresFrmDatosFiscales.rfc ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.rfc} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="nombre">* Nombre o Razón Social:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <InputText id="nombre" name="receptor.nombre" value={receptor.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresFrmDatosFiscales.nombre ? 'p-error' : ''} placeholder="Nombre o Razón Social" />
                                    {erroresFrmDatosFiscales.nombre ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.nombre} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="domicilioFiscalReceptor">* Domicilio Fiscal Receptor (Código postal):</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <InputText id="domicilioFiscalReceptor" maxLength={5} name="receptor.domicilioFiscalReceptor" value={receptor.domicilioFiscalReceptor || ''} onChange={this.asignarValoresObjeto} className={erroresFrmDatosFiscales.domicilioFiscalReceptor ? 'p-error' : ''} placeholder="Domicilio Fiscal (Código Postal)" />
                                    {erroresFrmDatosFiscales.domicilioFiscalReceptor ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.domicilioFiscalReceptor} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="regimenFiscalReceptor">* Regimen Fiscal:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <Dropdown dataKey="id" id="regimenFiscalReceptor" name="receptor.regimenFiscalReceptor" options={listaRegimenFiscalReceptor} value={receptor.regimenFiscalReceptor} onChange={this.asignarValoresObjeto} itemTemplate={this.templateRegimenFiscal} optionLabel="descripcion" className={erroresFrmDatosFiscales.regimenFiscalReceptor ? 'p-error' : ''} />
                                    {erroresFrmDatosFiscales.regimenFiscalReceptor ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.regimenFiscalReceptor} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="usoCfdi">* Uso del CFDI:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <Dropdown dataKey="id" id="usoCfdi" name="receptor.usoCfdi" options={usosCfdi} value={receptor.usoCfdi} onChange={this.asignarValoresObjeto} itemTemplate={this.templateUsoCfdi} optionLabel="descripcion" className={erroresFrmDatosFiscales.usoCfdi ? 'p-error' : ''} />
                                    {erroresFrmDatosFiscales.usoCfdi ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.usoCfdi} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="correo">* Correo:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <InputText id="correo" name="receptor.correo" value={receptor.correo || ''} onChange={this.asignarValoresObjeto} className={erroresFrmDatosFiscales.correo ? 'p-error' : ''} placeholder="Correo electrónico" onFocus={this.muestramensajecorreos} />
                                    {erroresFrmDatosFiscales.correo ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.correo} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-4" style={{ marginTop: '10px' }}>
                                    <label htmlFor="domicilio"> Complemento para la facturación de partidos políticos</label>
                                </div>
                                <div className="p-col-12 p-md-8" style={{ marginTop: '10px' }}>
                                    <Checkbox inputId="cb1" value="Complemento para la facturación de partidos políticos" checked={mostrarComplementoIne} onChange={this.crearEliminarComplmentoIne}></Checkbox>
                                </div>
                            </div>
                        </div>
                    </div>




                </div>
                {mostrarComplementoIne ? <div className="card card-w-title">
                    <h4 style={{ marginTop: '1px', marginBottom: '30px', fontWeight: 'bold' }}>Complemento INE</h4>
                    <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="tipoproceso">Tipo Proceso</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Dropdown dataKey="llave" id="tipoproceso" name="complementoIne.tipoProceso" placeholder="Selecciona" options={elementosComplementoIne.tiposProceso} value={complementoIne.tipoProceso} onChange={this.validarTipoProceso} optionValue="llave" optionLabel="valor" />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="tipoComite">Tipo Comite</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Dropdown dataKey="llave" id="tipoComite" name="complementoIne.tipoComite" placeholder="Selecciona" options={elementosComplementoIne.tiposComite} value={complementoIne.tipoComite} onChange={this.validarTipoComite} optionValue="llave" optionLabel="valor" disabled={desActivarTipoComite} />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="idContabilidad">Id Contabilidad</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText id="idContabilidad" name="complementoIne.idContabilidad" value={complementoIne.idContabilidad || ''} onChange={this.asignarValoresObjeto} placeholder="Id Contabilidad" keyfilter="pint" disabled={desActivar_complementoIne_idContabilidad} maxlength="6" />
                            {erroresFrmDatosFiscales.rfc ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.rfc} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="claveEntidad">Clave Entidad</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Dropdown dataKey="llave" id="entidad" name="complementoIne.entidad_claveEntidad" placeholder="Selecciona" options={elementosComplementoIne.clavesEntidad} value={complementoIne.entidad_claveEntidad} onChange={this.asignarValoresObjeto} optionValue="llave" optionLabel="valor" disabled={desActivar_entidad_claveEntidad} />
                            {erroresFrmDatosFiscales.usoCfdi ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.usoCfdi} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="rfc">Ambito</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Dropdown dataKey="llave" id="ambito" name="complementoIne.entidad_ambito" placeholder="Selecciona" options={elementosComplementoIne.tiposAmbito} value={complementoIne.entidad_ambito} onChange={this.asignarValoresObjeto} optionValue="llave" optionLabel="valor" disabled={desActivar_entidad_ambito} />
                            {erroresFrmDatosFiscales.usoCfdi ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.usoCfdi} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="rfc">Entidad Id Contabilidad</label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText id="entidad_contabilidad_idContabilidad" name="complementoIne.entidad_contabilidad_idContabilidad" value={complementoIne.entidad_contabilidad_idContabilidad || ''} onChange={this.asignarValoresObjeto} placeholder="Entidad Id Contabilidad" keyfilter="pint" disabled={desActivar_entidad_contabilidad_idContabilidad} maxlength="6" />
                        </div>
                    </div>
                </div> : null}



                <div className="card card-w-title">
                    <h4 style={{ marginTop: '1px', marginBottom: '30px', fontWeight: 'bold' }}>Capturar códigos</h4>

                    {mostrarSeccionLectorQr ? seccionLectorQr : null}


                    <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="codigo">* Concepto a facturar (Ticket):</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <div className="p-inputgroup">
                                <InputText id="codigo" name="ticket.codigo" value={ticket.codigo || ''} onChange={this.asignarValoresObjeto} className={erroresFrmTicket.codigo ? 'p-error' : ''} placeholder="Código de 18 caracteres" size="18" />
                            </div>
                            {erroresFrmTicket.codigo ? <div><br /> <Message severity="error" text={erroresFrmTicket.codigo} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Button type="submit" icon="pi-md-check" label="Validar Código" className="p-button-rounded p-button-success" onClick={this.validarCodigo} />
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Button type="submit" icon="pi-md-camera-alt" label={textoBotonQr} className="p-button-rounded p-button-warning" onClick={this.activarLectorQr} />
                        </div>
                    </div>

                    <DataTable value={tickets} header="CÓDIGOS AGREGADOS" editable={true} responsive={true} resizableColumns={true} style={{ marginTop: '20px' }}>
                        <Column body={this.templateBorrarTicket} style={{ textAlign: 'center', width: '8em' }} />
                        <Column field="2" header="Código" />
                        <Column field="1" header="Plaza de cobro" />
                        <Column body={this.templateColumnaFecha} editor={this.editorColumnaFecha} header="Fecha" />
                        <Column body={this.templateColumnaImporte} header="Costo" />
                    </DataTable>
                    <Dialog header="¿Eliminar el código?" visible={mostrarModalEliminar} style={{ width: '50vw' }} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalEliminar} onHide={this.cerrarEliminarCodigo}>
                        ¿Está usted seguro de eliminar el código {elTicket} ?
                    </Dialog>

                    <div className="card">
                        {tickets.length > 0 ? <div className="p-grid">
                            <div className="p-col-12 p-md-4"></div>
                            <div className="p-col-12 p-md-4">
                                <h1>Deseo mis códigos en varios CFDI</h1>
                                <label htmlFor="codigoPorCfdi">Quiero un CFDI por código capturado:</label>
                                <Checkbox id="codigoPorCfdi" checked={cfdiPorCodigo} onChange={e => { this.setState({ cfdiPorCodigo: e.checked }) }} tooltip="Esta opción aplica solo si deseas que se genere un CFDI por cada uno de tus códigos capturados, es decir si ingresas 5 códigos entonces tendras 5 CFDI's, si ingresas 20 códigos entonces tendras 20 CFDI's, CAPUFE siempre ha clasificado los códigos por forma de pago asi como por red carretera(Actualmente 3 redes carreteras), selecciona esta opción si deseas 1 cfdi por código de lo contrario no la selecciones"></Checkbox>
                            </div>
                            <div className="p-col-12 p-md-4"></div>
                        </div> : null}
                        <div className="p-grid">
                            <div className="p-col-12 p-md-4"></div>
                            <div className="p-col-12 p-md-4">
                                {tickets.length > 0 ? <Button onClick={this.pre_facturar} label="Facturar conceptos" className="p-button-rounded p-button-info" /> : null}</div>
                            <div className="p-col-12 p-md-4"></div>
                        </div>
                    </div>
                    <Dialog appendTo={document.body} header="Confirmación" visible={this.state.confirmacionFacturacion} modal={true} footer={dialogFooterConfirmacionFacturacion} onHide={this.cerrarModalConfirmacion}>
                        <p><h2 className="rojo">"Una vez emitida la factura no se podrá remitir a un RFC diferente ni corregir datos"</h2></p>
                        <p><h3 className="rojo">Es importante que verifique la fecha de sus códigos mostrados en pantalla, en caso de que la fecha de alguno de sus códigos no sea la correcta cierre esta ventana y seleccione la fecha correcta de su código(s), si existiera alguna inconsistencia en la fecha de alguno de los códigos podrá ver el botón <Button type="button" icon="pi-md-edit" className="p-button-warning"></Button> en la tabla de códigos</h3></p>
                        <p><h3>¿Estás seguro de que esta información es correcta?</h3></p>
                        <p><h3>Click en el botón <strong>"Si estoy seguro"</strong> para iniciar el proceso de facturación, de lo contrario, da Click en el botón <strong>"No estoy seguro"</strong>.</h3></p>
                    </Dialog>
                    <Dialog appendTo={document.body} header="Resultado facturación" visible={mostrarModalResultado} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalRestultados} onHide={this.cerrarModalResultados}>
                        <DataTable value={listaResultados} header="Facturas generadas" responsive={true}>
                            <Column body={this.templateErrorResultado} header="Estado" />
                            <Column field="mensaje" header="Observación" />
                            <Column field="objeto.uuid" header="UUID" />
                            <Column field="objeto.serie" header="Serie" />
                            <Column field="objeto.folio" header="Folio" />
                            <Column body={this.templateDescargaArchivos} style={{ textAlign: 'center', width: '8em' }} header="Descargar archivos" />
                        </DataTable>
                    </Dialog>
                </div>
            </div>);
    }


}